export const PRODUCTS_URL = '/advertising/catalog/products';

export const SHOPS_URL = '/advertising/catalog/shops';
